import { render, staticRenderFns } from "./Percent.vue?vue&type=template&id=768d9b22&scoped=true&"
import script from "./Percent.vue?vue&type=script&lang=js&"
export * from "./Percent.vue?vue&type=script&lang=js&"
import style0 from "./Percent.vue?vue&type=style&index=0&id=768d9b22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768d9b22",
  null
  
)

export default component.exports